import { ArrivalTypeModel } from "../../models/medical-record/arrival-type.model";

export class ArrivalTypeStruct {
    public arrivalTypeNotDefault: ArrivalTypeModel;
    public isCreate: boolean;
    constructor() {
        this.arrivalTypeNotDefault = new ArrivalTypeModel();
    }
}